import styled from 'styled-components';

import {BorderBaseDefault} from '@/componentLibrary/tokens/customVariables';

export const StyledTr = styled.tr`
    border-bottom: ${BorderBaseDefault};
`;
